import Chatbot from "./Chatbot";
import "./chatbot.css";
import { useState, useRef, useCallback, useEffect } from "react";
import "./App.css";

const BASE = "/api";

const DASHBOARD_FORMAT = [
  { section:"A", type:"data",  plant:"Lead Residue", label:"Lead bearing residue",            loc:"Pyro RM storage",      uom:"MT", code:"20002002" },
  { section:"A", type:"data",  plant:"PF Cake",      label:"PF cake RGTPL",                   loc:"Hydro RM storage",     uom:"MT", code:"20002000" },
  { section:"A", type:"data",  plant:"Cadmium",      label:"Cadmium Sponge SFG",              loc:"Cadmium RM storage",   uom:"MT", code:"SFG20000" },
  { section:"A", type:"data",  plant:"Cobalt",       label:"Cobalt Filter Cake",              loc:"Co plant shop floor",  uom:"MT", code:"SFG20001" },
  { section:"A", type:"data",  plant:"Copper",       label:"Cu Matte- Pyro",                  loc:"Cu Matte RM storage",  uom:"MT", code:"SFG20017" },
  { section:"B", type:"group", plant:"Lead Residue", label:"1. Lead Residue" },
  { section:"B", type:"data",  plant:"Lead Residue", label:"Pb Bullion- Cu dross",            loc:null, uom:"MT", code:"FG20005"  },
  { section:"B", type:"data",  plant:"Lead Residue", label:"Cu Matte- Pyro",                  loc:"Pyro shop floor", uom:"MT", code:"SFG20017" },
  { section:"B", type:"data",  plant:"Lead Residue", label:"Bag house dust - Cu Dross",       loc:"Pyro shop floor", uom:"MT", code:"SFG20018" },
  { section:"B", type:"group", plant:"PF Cake",      label:"2. PF Cake Plant" },
  { section:"B", type:"data",  plant:"PF Cake",      label:"Zinc Sulphate solution PF cake",  loc:null, uom:"MT", code:"FG20000"  },
  { section:"B", type:"data",  plant:"PF Cake",      label:"Copper cement SFG",               loc:null, uom:"MT", code:"SFG20002" },
  { section:"B", type:"data",  plant:"PF Cake",      label:"Cadmium Sponge SFG",              loc:null, uom:"MT", code:"SFG20000" },
  { section:"B", type:"data",  plant:"PF Cake",      label:"Cobalt Filter Cake",              loc:"Hydro shop floor", uom:"MT", code:"SFG20001" },
  { section:"B", type:"data",  plant:"PF Cake",      label:"CuSO4",                           loc:null, uom:"MT", code:"SFG20019" },
  { section:"B", type:"group", plant:"Cadmium",      label:"3. Cadmium Plant" },
  { section:"B", type:"data",  plant:"Cadmium",      label:"Cadmium Ingots",                  loc:null, uom:"MT", code:"FG20001"  },
  { section:"B", type:"data",  plant:"Cadmium",      label:"Cd Cone",                         loc:null, uom:"MT", code:"SFG20016" },
  { section:"B", type:"data",  plant:"Cadmium",      label:"Zinc Residue - Cd plant grade 2", loc:null, uom:"MT", code:"SFG20004" },
  { section:"B", type:"data",  plant:"Cadmium",      label:"Crude Cadmium",                   loc:null, uom:"MT", code:"SFG20014" },
  { section:"B", type:"data",  plant:"Cadmium",      label:"Zinc Residue Cd plant",           loc:null, uom:"MT", code:"SFG20005" },
  { section:"B", type:"data",  plant:"Cadmium",      label:"Skimming Material",               loc:null, uom:"MT", code:"SFG20003" },
  { section:"B", type:"data",  plant:"Cadmium",      label:"Bag House dust- Cd plant",        loc:null, uom:"MT", code:"SFG20013" },
  { section:"B", type:"group", plant:"Cobalt",       label:"4. Cobalt Plant" },
  { section:"B", type:"data",  plant:"Cobalt",       label:"Zinc Sulphate solution Co plant",  loc:null, uom:"MT", code:"FG20004"  },
  { section:"B", type:"data",  plant:"Cobalt",       label:"Zinc Residue Co plant",            loc:null, uom:"MT", code:"SFG20006" },
  { section:"B", type:"data",  plant:"Cobalt",       label:"Cobalt Filter cake grade 1",       loc:null, uom:"MT", code:"FG20003"  },
  { section:"B", type:"data",  plant:"Cobalt",       label:"Zinc Residue - Cd plant grade 2",  loc:null, uom:"MT", code:"SFG20004" },
  { section:"B", type:"data",  plant:"Cobalt",       label:"Acid leaching slag",               loc:null, uom:"MT", code:"SFG20007" },
  { section:"B", type:"data",  plant:"Cobalt",       label:"Iron slag-  Co plant",             loc:null, uom:"MT", code:"SFG20008" },
  { section:"B", type:"group", plant:"Copper",       label:"5. Copper Plant" },
  { section:"B", type:"data",  plant:"Copper",       label:"CuSO4 crystals",                   loc:null, uom:"M3", code:"FG20002"  },
  { section:"B", type:"data",  plant:"Copper",       label:"Copper Sponge",                    loc:null, uom:"MT", code:"SFG20010" },
  { section:"B", type:"data",  plant:"Copper",       label:"Iron slag- Cu plant",              loc:null, uom:"MT", code:"SFG20012" },
  { section:"B", type:"data",  plant:"Copper",       label:"Lead Silver slag",                 loc:null, uom:"MT", code:"SFG20011" },
];

const PLANT_COLORS = {
  "Lead Residue": { accent:"#C2410C", light:"#FFF0E6", badge:"#EA580C" },
  "PF Cake":      { accent:"#16A34A", light:"#F0FDF4", badge:"#22C55E" },
  "Cadmium":      { accent:"#1D4ED8", light:"#EFF6FF", badge:"#3B82F6" },
  "Cobalt":       { accent:"#7C3AED", light:"#F5F3FF", badge:"#8B5CF6" },
  "Copper":       { accent:"#B45309", light:"#FFF7ED", badge:"#F59E0B" },
};

function fmt(v) {
  if (v === null || v === undefined || v === 0 || v === "") return <span className="zero">—</span>;
  const n = Number(v);
  if (isNaN(n)) return <span className="zero">—</span>;
  // Show full precision - remove trailing zeros but keep all significant digits
  return n % 1 === 0 ? n.toLocaleString('en-IN') : n.toLocaleString('en-IN', {maximumFractionDigits: 10, minimumFractionDigits: 0});
}
function Badge({ plant }) {
  const c = PLANT_COLORS[plant] || { badge:"#6B7280", light:"#F3F4F6" };
  return <span className="badge" style={{ background:c.light, color:c.badge }}>{plant}</span>;
}

// ── Upload Tab ────────────────────────────────────────────────────────────────
function UploadTab({ onUploaded }) {
  const [sapState,   setSapState]   = useState({ status:"idle", rows:0, name:"" });
  const [stockState, setStockState] = useState({ status:"idle", rows:0, name:"" });
  const [history,    setHistory]    = useState([]);
  const [resetting,  setResetting]  = useState(false);
  const [resetMsg,   setResetMsg]   = useState("");
  const sapRef   = useRef(null);
  const stockRef = useRef(null);

  const uploadFile = async (file, endpoint, setState) => {
    setState({ status:"loading", rows:0, name:file.name });
    const fd = new FormData();
    fd.append("file", file);
    // Date is auto-extracted from filename on the backend
    const url = `${BASE}/upload/${endpoint}`;
    try {
      const r = await fetch(url, { method:"POST", body:fd });
      const d = await r.json();
      if (!r.ok) throw new Error(d.detail || "Upload failed");
      // Show auto-detected date in success message
      const detectedDate = d.stock_date ? `Date: ${d.stock_date}` : file.name;
      setState({ status:"done", rows:d.rows, name:file.name, detectedDate });
      onUploaded();
    } catch(e) {
      setState({ status:"error", rows:0, name:file.name, error:e.message });
    }
  };

  const handleReset = async () => {
    if (!window.confirm("This will DELETE all uploaded SAP data and closing stock. Are you sure?")) return;
    setResetting(true); setResetMsg("");
    try {
      const r = await fetch(`${BASE}/data/reset?confirm=YES_DELETE_ALL`, { method:"DELETE" });
      const d = await r.json();
      if (!r.ok) throw new Error(d.detail);
      setResetMsg("✓ All data cleared successfully.");
      setSapState({ status:"idle", rows:0, name:"" });
      setStockState({ status:"idle", rows:0, name:"" });
      setHistory([]);
    } catch(e) { setResetMsg("✗ " + e.message); }
    finally { setResetting(false); }
  };

  return (
    <div className="tab-content">
      <div className="page-header" style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",flexWrap:"wrap",gap:10}}>
        <div>
          <h1>Upload SAP Data</h1>
          <p>Upload SAP SAPUI5 Export daily. Mail sends automatically at your configured time.</p>
        </div>
        <button className="btn-danger" onClick={handleReset} disabled={resetting}>
          {resetting ? "Deleting…" : "🗑 Reset All Data"}
        </button>
      </div>

      {resetMsg && (
        <div className={resetMsg.startsWith("✓") ? "success-bar" : "error-bar"} style={{marginBottom:16}}>
          {resetMsg}
        </div>
      )}

      <div className="upload-grid">
        <div className={`upload-card ${sapState.status==="done"?"done":""} ${sapState.status==="error"?"error":""}`}
          onClick={() => sapRef.current.click()}
          onDragOver={e => e.preventDefault()}
          onDrop={e => { e.preventDefault(); const f=e.dataTransfer.files[0]; if(f) uploadFile(f,"sap",setSapState); }}>
          <div className="upload-icon">{sapState.status==="loading"?"⏳":sapState.status==="done"?"✅":"📊"}</div>
          <div className="upload-title">SAP Material Movements</div>
          <div className="upload-sub">SAPUI5 Export — upload this daily</div>
          <div style={{marginTop:14}}>
            {sapState.status==="done"    && <span className="chip green">✓ {sapState.rows} rows — {sapState.name}</span>}
            {sapState.status==="error"   && <span className="chip red">✗ {sapState.error}</span>}
            {sapState.status==="idle"    && <span className="chip gray">Click or drag to upload</span>}
            {sapState.status==="loading" && <span className="chip gray">Uploading…</span>}
          </div>
          <input ref={sapRef} type="file" accept=".xlsx,.xls,.csv" style={{display:"none"}}
            onChange={e => { const f=e.target.files[0]; if(f) uploadFile(f,"sap",setSapState); }} />
        </div>

        <div className={`upload-card ${stockState.status==="done"?"done":""} ${stockState.status==="error"?"error":""}`}
          onClick={() => stockRef.current.click()}
          onDragOver={e => e.preventDefault()}
          onDrop={e => { e.preventDefault(); const f=e.dataTransfer.files[0]; if(f) uploadFile(f,"stock",setStockState); }}>
          <div className="upload-icon">{stockState.status==="loading"?"⏳":stockState.status==="done"?"✅":"📦"}</div>
          <div className="upload-title">Closing Stock Data</div>
          <div className="upload-sub">
            Upload daily — date auto-detected from filename<br/>
            <span style={{fontSize:11,color:"#9CA3AF"}}>e.g. 17062026_closing_stock.xlsx</span>
          </div>
          <div style={{marginTop:14}}>
            {stockState.status==="done"    && <span className="chip green">✓ {stockState.rows} rows — {stockState.detectedDate || stockState.name}</span>}
            {stockState.status==="error"   && <span className="chip red">✗ {stockState.error}</span>}
            {stockState.status==="idle"    && <span className="chip gray">Click or drag to upload</span>}
            {stockState.status==="loading" && <span className="chip gray">Uploading…</span>}
          </div>
          <input ref={stockRef} type="file" accept=".xlsx,.xls,.csv" style={{display:"none"}}
            onChange={e => { const f=e.target.files[0]; if(f) uploadFile(f,"stock",setStockState); }} />
        </div>
      </div>

      <div className="format-note">
        <strong>Expected columns — SAP SAPUI5 Export:</strong> Material Document · Material Document Year · Material · Plant · Storage Location · Posting Date · Goods Movement Type · Stock Type · Quantity
      </div>

      <div style={{marginTop:24}}>
        <button className="btn-outline"
          onClick={async()=>{const r=await fetch(`${BASE}/uploads/history`);setHistory(await r.json());}}>
          Show upload history
        </button>
        {history.length>0 && (
          <table className="data-table" style={{marginTop:12}}>
            <thead><tr><th>File</th><th>Type</th><th>Rows</th><th>Uploaded at</th></tr></thead>
            <tbody>{history.map(h=>(
              <tr key={h.id}><td>{h.filename}</td><td>{h.file_type}</td><td>{h.row_count}</td><td>{h.uploaded_at?.slice(0,16)}</td></tr>
            ))}</tbody>
          </table>
        )}
      </div>
    </div>
  );
}

// ── Dashboard Tab ─────────────────────────────────────────────────────────────
function DashboardTab() {
  const [dbRows,      setDbRows]    = useState([]);
  const [kpi,         setKpi]       = useState({});
  const [loading,     setLoading]   = useState(false);
  const [filterSec,   setFilterSec] = useState("All");
  const [availDates,  setAvailDates]= useState([]);
  const [dateFrom,    setDateFrom]  = useState("");
  const [dateTo,      setDateTo]    = useState("");
  const [mode,        setMode]      = useState("daily"); // "daily" | "range"

  const load = useCallback(async (from, to) => {
    setLoading(true);
    try {
      let url = `${BASE}/dashboard`;
      const params = new URLSearchParams();
      if (from) params.append("date_from", from);
      if (to)   params.append("date_to",   to);
      if (params.toString()) url += "?" + params.toString();
      const r = await fetch(url);
      const d = await r.json();
      setDbRows(d.rows || []);
      setKpi(d.kpi || {});
      setAvailDates(d.available_dates || []);
      // Set defaults on first load
      if (!from && d.kpi?.ftd) {
        setDateFrom(d.kpi.ftd);
        setDateTo(d.kpi.ftd);
      }
    } finally { setLoading(false); }
  }, []);

  useEffect(() => { load(null, null); }, [load]);

  const handleApply = () => {
    if (mode === "daily") {
      load(dateTo, dateTo);
    } else {
      load(dateFrom, dateTo);
    }
  };

  const handleModeChange = (m) => {
    setMode(m);
    if (m === "daily" && dateTo) {
      load(dateTo, dateTo);
    }
  };

  const downloadExcel = async () => {
    try {
      // Always pass both dates so backend filters correctly
      const from = mode === "daily" ? dateTo : (dateFrom || dateTo);
      const to   = dateTo || kpi.ftd || "";
      const params = new URLSearchParams();
      if (from) params.append("date_from", from);
      if (to)   params.append("date_to",   to);
      const label = mode === "daily" ? to : `${from}_to_${to}`;
      const r = await fetch(`${BASE}/download/excel?${params}`);
      if (!r.ok) { alert("Download failed — check data is loaded"); return; }
      const blob = await r.blob();
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `DPR_${label}.xlsx`;
      a.click();
      URL.revokeObjectURL(a.href);
    } catch(e) { alert("Error: " + e.message); }
  };

  const isDaily  = mode === "daily";
  const getRow   = (code, plant) => dbRows.find(r => r.code===code && r.plant===plant) || {};
  const secA     = DASHBOARD_FORMAT.filter(r => r.section==="A");
  const secB     = DASHBOARD_FORMAT.filter(r => r.section==="B");

  const ftdLabel  = isDaily ? "Day Total"    : "Day (To Date)";
  const mtdLabel  = isDaily ? "—"            : "Range Total";
  const showMTD   = !isDaily;

  return (
    <div className="tab-content">
      {/* Header */}
      <div className="page-header" style={{display:"flex",alignItems:"flex-start",justifyContent:"space-between",flexWrap:"wrap",gap:10}}>
        <div>
          <h1>Production Dashboard</h1>
          <p>
            {isDaily
              ? <>Showing: <strong>{dateTo || kpi.ftd || "—"}</strong> &nbsp;·&nbsp; {kpi.totalMovements||0} movements</>
              : <>Showing: <strong>{dateFrom}</strong> to <strong>{dateTo}</strong> &nbsp;·&nbsp; {kpi.totalMovements||0} movements</>
            }
          </p>
        </div>
        <div style={{display:"flex",gap:8}}>
          <button className="btn-outline" onClick={downloadExcel}>⬇ Download Excel</button>
          <button className="btn-primary" onClick={() => load(isDaily?dateTo:dateFrom, dateTo)} disabled={loading}>
            {loading?"Refreshing…":"↺ Refresh"}
          </button>
        </div>
      </div>

      {/* Date filter bar */}
      <div className="date-filter-bar">
        {/* Mode toggle */}
        <div className="mode-toggle">
          <button className={`mode-btn ${isDaily?"active":""}`} onClick={()=>handleModeChange("daily")}>
            📅 Daily
          </button>
          <button className={`mode-btn ${!isDaily?"active":""}`} onClick={()=>handleModeChange("range")}>
            📆 Date Range
          </button>
        </div>

        {isDaily ? (
          <>
            <label className="filter-label">Select Date:</label>
            <select className="date-select" value={dateTo}
              onChange={e=>{setDateTo(e.target.value);load(e.target.value,e.target.value);}}>
              {availDates.map(d=><option key={d} value={d}>{d}</option>)}
            </select>
          </>
        ) : (
          <>
            <label className="filter-label">From:</label>
            <input type="date" className="date-input" value={dateFrom}
              onChange={e=>setDateFrom(e.target.value)}
              min={availDates[0]||""} max={availDates[availDates.length-1]||""}/>
            <label className="filter-label">To:</label>
            <input type="date" className="date-input" value={dateTo}
              onChange={e=>setDateTo(e.target.value)}
              min={availDates[0]||""} max={availDates[availDates.length-1]||""}/>
            <button className="btn-primary" style={{padding:"6px 16px"}} onClick={handleApply} disabled={loading}>
              Apply
            </button>
          </>
        )}

        <div style={{marginLeft:"auto",display:"flex",gap:8,alignItems:"center"}}>
          <label className="filter-label">Section:</label>
          <select value={filterSec} onChange={e=>setFilterSec(e.target.value)}>
            <option value="All">All</option>
            <option value="A">Section A</option>
            <option value="B">Section B</option>
          </select>
        </div>
      </div>



      {/* Section A */}
      {(filterSec==="All"||filterSec==="A") && (
        <div className="table-section">
          <div className="section-head dark">A. Input — Smelter Residue</div>
          <div className="table-wrap">
            <table className="data-table">
              <thead>
                <tr>
                  <th className="left" rowSpan="2">Material</th>
                  <th className="left" rowSpan="2">Storage Location</th>
                  <th className="center" rowSpan="2">UOM</th>
                  <th className="center" colSpan={showMTD?2:1}>Material Processed</th>
                  <th className="center" colSpan={showMTD?2:1}>Received</th>
                  <th className="center" rowSpan="2">Opening Stock</th>
                  <th className="center" rowSpan="2">Closing Stock</th>
                </tr>
                <tr>
                  <th className="center">{ftdLabel}</th>
                  {showMTD && <th className="center">{mtdLabel}</th>}
                  <th className="center">{ftdLabel}</th>
                  {showMTD && <th className="center">{mtdLabel}</th>}
                </tr>
              </thead>
              <tbody>
                {secA.map((row,i)=>{
                  const d=getRow(row.code,row.plant);
                  return (<tr key={i}>
                    <td className="left"><Badge plant={row.plant}/><span style={{marginLeft:8}}>{row.label}</span></td>
                    <td className="left muted">{row.loc||"—"}</td>
                    <td className="center muted">{row.uom}</td>
                    <td className={`center ${d.prodFTD>0?"bold":""}`}>{fmt(d.prodFTD)}</td>
                    {showMTD && <td className="center">{fmt(d.prodMTD)}</td>}
                    <td className={`center ${d.rcptFTD>0?"green":""}`}>{fmt(d.rcptFTD)}</td>
                    {showMTD && <td className={`center ${d.rcptMTD>0?"green":""}`}>{fmt(d.rcptMTD)}</td>}
                    <td className="center amber">{fmt(d.openingStock)}</td>
                    <td className="center blue bold">{fmt(d.closingStock)}</td>
                  </tr>);
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Section B */}
      {(filterSec==="All"||filterSec==="B") && (
        <div className="table-section">
          <div className="section-head dark">B. Output (Recovery)</div>
          <div className="table-wrap">
            <table className="data-table">
              <thead>
                <tr>
                  <th className="left" rowSpan="2">Material</th>
                  <th className="center" rowSpan="2">UOM</th>
                  <th className="center" colSpan={showMTD?2:1}>Production</th>
                  <th className="center" colSpan={showMTD?2:1}>Dispatches</th>
                  <th className="center" rowSpan="2">Opening Stock</th>
                  <th className="center" rowSpan="2">Closing Stock</th>
                </tr>
                <tr>
                  <th className="center">{ftdLabel}</th>
                  {showMTD && <th className="center">{mtdLabel}</th>}
                  <th className="center">{ftdLabel}</th>
                  {showMTD && <th className="center">{mtdLabel}</th>}
                </tr>
              </thead>
              <tbody>
                {secB.map((row,i)=>{
                  if(row.type==="group"){
                    const c=PLANT_COLORS[row.plant]||{accent:"#374151",light:"#F8FAFC"};
                    const cols = showMTD ? 8 : 6;
                    return (<tr key={i}><td colSpan={cols} style={{background:c.light,padding:"8px 14px",fontWeight:600,fontSize:13,borderLeft:`3px solid ${c.accent}`,color:c.accent}}>{row.label}</td></tr>);
                  }
                  const d=getRow(row.code,row.plant);
                  const c=PLANT_COLORS[row.plant]||{};
                  return (<tr key={i}>
                    <td className="left" style={{paddingLeft:20}}>{row.label}</td>
                    <td className="center muted">{row.uom}</td>
                    <td className="center" style={{fontWeight:d.prodFTD>0?600:400,color:d.prodFTD>0?(c.accent||"inherit"):"inherit"}}>{fmt(d.prodFTD)}</td>
                    {showMTD && <td className="center">{fmt(d.prodMTD)}</td>}
                    <td className={`center ${d.dispFTD>0?"green bold":""}`}>{fmt(d.dispFTD)}</td>
                    {showMTD && <td className={`center ${d.dispMTD>0?"green":""}`}>{fmt(d.dispMTD)}</td>}
                    <td className="center amber">{fmt(d.openingStock)}</td>
                    <td className="center blue bold">{fmt(d.closingStock)}</td>
                  </tr>);
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}

// ── Mail Settings Tab ─────────────────────────────────────────────────────────
function MailTab() {
  const DAYS = ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"];
  const FREQ_LABEL = {daily:"Daily",weekly:"Weekly",monthly:"Monthly"};

  const blank = {
    name:"", to_email:"", cc_email:"",
    subject_template:"RGTPL Daily Production Report — {date}",
    body_template:"", send_time:"18:00",
    frequency:"daily", week_day:0, month_day:1, auto_send:true
  };

  const [schedules, setSchedules] = useState([]);
  const [form,      setForm]      = useState(blank);
  const [editId,    setEditId]    = useState(null);  // null = new, number = editing
  const [saving,    setSaving]    = useState(false);
  const [saved,     setSaved]     = useState("");
  const [testing,   setTesting]   = useState(null);
  const [testMsg,   setTestMsg]   = useState({});
  const [history,   setHistory]   = useState([]);
  const [showPrev,  setShowPrev]  = useState(false);
  const [preview,   setPreview]   = useState({subject:"",body:""});

  const load = async () => {
    const r = await fetch(`${BASE}/mail/config`);
    const d = await r.json();
    setSchedules(Array.isArray(d) ? d : (d.id ? [d] : []));
  };
  useEffect(() => { load(); }, []);

  const handleSave = async () => {
    if (!form.to_email) { alert("To email is required"); return; }
    setSaving(true); setSaved("");
    try {
      let r;
      if (editId) {
        r = await fetch(`${BASE}/mail/config/${editId}`, {method:"PUT", headers:{"Content-Type":"application/json"}, body:JSON.stringify(form)});
      } else {
        r = await fetch(`${BASE}/mail/config`, {method:"POST", headers:{"Content-Type":"application/json"}, body:JSON.stringify(form)});
      }
      const d = await r.json();
      if (!r.ok) throw new Error(d.detail);
      setSaved(editId ? "✓ Schedule updated" : "✓ New schedule added");
      setForm(blank); setEditId(null);
      load();
    } catch(e) { alert("Error: "+e.message); }
    finally { setSaving(false); setTimeout(()=>setSaved(""),3000); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this schedule?")) return;
    await fetch(`${BASE}/mail/config/${id}`, {method:"DELETE"});
    load();
  };

  const handleToggle = async (id) => {
    await fetch(`${BASE}/mail/config/${id}/toggle`, {method:"PATCH"});
    load();
  };

  const handleEdit = (s) => {
    setForm({
      name: s.name||"", to_email:s.to_email, cc_email:s.cc_email||"",
      subject_template:s.subject_template||"RGTPL Daily Production Report — {date}",
      body_template:s.body_template||"", send_time:s.send_time||"18:00",
      frequency:s.frequency||"daily", week_day:s.week_day||0, month_day:s.month_day||1,
      auto_send:!!s.auto_send
    });
    setEditId(s.id);
    window.scrollTo({top:0, behavior:"smooth"});
  };

  const handleTest = async (id) => {
    setTesting(id); setTestMsg({...testMsg,[id]:""});
    try {
      const r = await fetch(`${BASE}/mail/test?config_id=${id}`, {method:"POST"});
      const d = await r.json();
      if (!r.ok) throw new Error(d.detail);
      setTestMsg({...testMsg,[id]:"✓ Sent"});
    } catch(e) { setTestMsg({...testMsg,[id]:"✗ "+e.message}); }
    finally { setTesting(null); }
  };

  const handlePreview = async () => {
    const r = await fetch(`${BASE}/mail/preview`);
    const d = await r.json();
    setPreview(d); setShowPrev(true);
  };

  const freqText = (s) => {
    if (s.frequency==="weekly")  return `Weekly — ${DAYS[s.week_day||0]}`;
    if (s.frequency==="monthly") return `Monthly — Day ${s.month_day}`;
    return "Daily";
  };

  return (
    <div className="tab-content">
      <div className="page-header">
        <h1>Mail Schedules</h1>
        <p>Add multiple independent schedules — each with its own recipient, time and frequency.</p>
      </div>

      {/* Form */}
      <div className="card" style={{marginBottom:24}}>
        <div className="card-title">{editId ? "✏️ Edit Schedule" : "➕ Add New Schedule"}</div>

        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14}}>
          <div>
            <label>Schedule Name</label>
            <input value={form.name} onChange={e=>setForm({...form,name:e.target.value})} placeholder="e.g. GM Daily, Board Weekly"/>
          </div>
          <div>
            <label>Send Time <span style={{color:"#9CA3AF",fontSize:11}}>(24hr format)</span></label>
            <input value={form.send_time} onChange={e=>setForm({...form,send_time:e.target.value})} placeholder="18:00"/>
          </div>
          <div>
            <label>To Email <span style={{color:"#EF4444"}}>*</span> <span style={{color:"#9CA3AF",fontSize:11}}>(comma separated for multiple)</span></label>
            <input value={form.to_email} onChange={e=>setForm({...form,to_email:e.target.value})} placeholder="gm@rgtpl.com, ops@rgtpl.com"/>
          </div>
          <div>
            <label>CC Email <span style={{color:"#9CA3AF",fontSize:11}}>(optional)</span></label>
            <input value={form.cc_email} onChange={e=>setForm({...form,cc_email:e.target.value})} placeholder="accounts@rgtpl.com"/>
          </div>
          <div>
            <label>Frequency</label>
            <select style={{width:"100%",padding:"9px 12px",border:"1px solid #E5E7EB",borderRadius:8,fontSize:13,fontFamily:"inherit",marginBottom:0}}
              value={form.frequency} onChange={e=>setForm({...form,frequency:e.target.value})}>
              <option value="daily">Daily — every day</option>
              <option value="weekly">Weekly — once a week</option>
              <option value="monthly">Monthly — once a month</option>
            </select>
          </div>
          {form.frequency==="weekly" && (
            <div>
              <label>Day of Week</label>
              <select style={{width:"100%",padding:"9px 12px",border:"1px solid #E5E7EB",borderRadius:8,fontSize:13,fontFamily:"inherit"}}
                value={form.week_day} onChange={e=>setForm({...form,week_day:parseInt(e.target.value)})}>
                {DAYS.map((d,i)=><option key={i} value={i}>{d}</option>)}
              </select>
            </div>
          )}
          {form.frequency==="monthly" && (
            <div>
              <label>Day of Month</label>
              <input type="number" min="1" max="28" value={form.month_day}
                onChange={e=>setForm({...form,month_day:parseInt(e.target.value)})} placeholder="1"/>
            </div>
          )}
        </div>

        <div style={{marginTop:14}}>
          <label>Subject Line</label>
          <input value={form.subject_template} onChange={e=>setForm({...form,subject_template:e.target.value})} placeholder="RGTPL Daily Production Report — {date}"/>
          <div style={{fontSize:11,color:"#9CA3AF",marginTop:-10,marginBottom:12}}>Use <code style={{background:"#F3F4F6",padding:"1px 4px",borderRadius:3}}>{"{date}"}</code> as placeholder</div>
        </div>

        <div style={{display:"flex",gap:8,marginTop:4}}>
          <button className="btn-primary" style={{flex:1}} onClick={handleSave} disabled={saving}>
            {saving?"Saving…": editId?"💾 Update Schedule":"➕ Add Schedule"}
          </button>
          {editId && (
            <button className="btn-outline" onClick={()=>{setForm(blank);setEditId(null);}}>Cancel</button>
          )}
          <button className="btn-outline" onClick={handlePreview}>👁 Preview</button>
        </div>
        {saved && <div className="success-bar" style={{marginTop:10}}>{saved}</div>}
      </div>

      {/* Preview */}
      {showPrev && (
        <div className="card" style={{marginBottom:24}}>
          <div className="card-title" style={{display:"flex",justifyContent:"space-between"}}>
            <span>👁 Mail Preview</span>
            <button className="btn-outline" style={{fontSize:11,padding:"2px 8px"}} onClick={()=>setShowPrev(false)}>✕</button>
          </div>
          <div style={{fontSize:12,color:"#6B7280",marginBottom:4}}>Subject:</div>
          <div style={{background:"#F8FAFC",padding:"8px 12px",borderRadius:6,fontSize:13,marginBottom:12,fontWeight:500}}>{preview.subject||"—"}</div>
          <div style={{fontSize:12,color:"#6B7280",marginBottom:4}}>Body:</div>
          <pre style={{background:"#F8FAFC",padding:"12px",borderRadius:6,fontSize:11,fontFamily:"monospace",whiteSpace:"pre-wrap",maxHeight:260,overflow:"auto"}}>{preview.body||"No data"}</pre>
        </div>
      )}

      {/* Saved Schedules */}
      <div className="card" style={{marginBottom:24}}>
        <div className="card-title" style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <span>📋 Saved Schedules ({schedules.length})</span>
          <button className="btn-outline" style={{fontSize:12,padding:"4px 10px"}} onClick={load}>↺ Refresh</button>
        </div>
        {schedules.length===0 ? (
          <div style={{textAlign:"center",padding:"30px 0",color:"#9CA3AF"}}>
            <div style={{fontSize:28,marginBottom:8}}>📭</div>
            <div style={{fontSize:13}}>No schedules yet — add one above</div>
          </div>
        ) : (
          <div style={{display:"flex",flexDirection:"column",gap:10}}>
            {schedules.map(s=>(
              <div key={s.id} style={{
                border:"1px solid #E5E7EB", borderRadius:10, padding:"14px 16px",
                background: s.auto_send ? "#fff" : "#F9FAFB",
                opacity: s.auto_send ? 1 : 0.7
              }}>
                <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",flexWrap:"wrap",gap:8}}>
                  <div style={{display:"flex",alignItems:"center",gap:10}}>
                    <div style={{
                      width:10,height:10,borderRadius:"50%",
                      background:s.auto_send?"#22C55E":"#9CA3AF",flexShrink:0
                    }}/>
                    <div>
                      <div style={{fontWeight:600,fontSize:13,color:"#1A1D23"}}>{s.name||`Schedule #${s.id}`}</div>
                      <div style={{fontSize:12,color:"#6B7280",marginTop:2}}>
                        📧 {s.to_email}
                        {s.cc_email && <span> &nbsp;|&nbsp; CC: {s.cc_email}</span>}
                      </div>
                      <div style={{fontSize:12,color:"#6B7280",marginTop:1}}>
                        🕐 {s.send_time} &nbsp;|&nbsp; 📅 {freqText(s)}
                      </div>
                    </div>
                  </div>
                  <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                    <button className="btn-outline" style={{fontSize:11,padding:"4px 10px"}}
                      onClick={()=>handleToggle(s.id)}>
                      {s.auto_send?"⏸ Pause":"▶ Resume"}
                    </button>
                    <button className="btn-outline" style={{fontSize:11,padding:"4px 10px"}}
                      onClick={()=>handleEdit(s)}>✏️ Edit</button>
                    <button className="btn-outline" style={{fontSize:11,padding:"4px 10px"}}
                      onClick={()=>handleTest(s.id)} disabled={testing===s.id}>
                      {testing===s.id?"Sending…":"📨 Test"}
                    </button>
                    <button className="btn-danger" style={{fontSize:11,padding:"4px 10px"}}
                      onClick={()=>handleDelete(s.id)}>🗑</button>
                  </div>
                </div>
                {testMsg[s.id] && (
                  <div className={testMsg[s.id].startsWith("✓")?"success-bar":"error-bar"}
                    style={{marginTop:8,fontSize:12}}>{testMsg[s.id]}</div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>

      {/* History */}
      <div className="card">
        <div className="card-title" style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <span>📜 Send History</span>
          <button className="btn-outline" style={{fontSize:12,padding:"4px 10px"}}
            onClick={async()=>{const r=await fetch(`${BASE}/mail/history`);setHistory(await r.json());}}>Load</button>
        </div>
        {history.length===0 ? (
          <div style={{textAlign:"center",padding:"20px 0",color:"#9CA3AF",fontSize:13}}>Click Load to view history</div>
        ) : (
          <table className="data-table" style={{marginTop:8}}>
            <thead><tr>
              <th className="left">Sent at</th><th className="left">To</th>
              <th className="left">Subject</th><th className="center">Status</th>
            </tr></thead>
            <tbody>{history.map(h=>(
              <tr key={h.id}>
                <td className="left muted">{h.sent_at?.slice(0,16)}</td>
                <td className="left">{h.to_email}</td>
                <td className="left muted" style={{maxWidth:200,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{h.subject}</td>
                <td className="center"><span className={`chip ${h.status==="sent"?"green":"red"}`}>{h.status}</span></td>
              </tr>
            ))}</tbody>
          </table>
        )}
      </div>
    </div>
  );
}


export default function App() {
  const [tab,setTab]=useState("upload");
  const [dbLive,setDbLive]=useState(false);
  useEffect(()=>{fetch(`${BASE}/health`).then(r=>setDbLive(r.ok)).catch(()=>setDbLive(false));},[]);
  return (
    <div className="app">
      <header className="topbar">
        <div className="topbar-left"><span className="logo">RGTPL DPR</span><span className="logo-sub">Daily Production Report</span></div>
        <nav className="topbar-nav">
          {[["upload","⬆ Upload"],["dashboard","▦ Dashboard"],["mail","✉ Mail Settings"],["chat","💬 Analytics"]].map(([k,l])=>(
            <button key={k} className={`nav-btn ${tab===k?"active":""}`} onClick={()=>setTab(k)}>{l}</button>
          ))}
        </nav>
        <div className="topbar-right">
          <span className={`status-dot ${dbLive?"live":"offline"}`}></span>
          <span className="status-label">{dbLive?"API connected":"API offline"}</span>
        </div>
      </header>
      <main className="main" style={{overflow: tab==="chat" ? "hidden" : "auto", display: tab==="chat" ? "block" : undefined}}>
        {tab==="upload"    && <UploadTab onUploaded={()=>setDbLive(true)}/>}
        {tab==="dashboard" && <DashboardTab/>}
        {tab==="mail"      && <MailTab/>}
        {tab==="chat"      && <Chatbot/>}
      </main>
    </div>
  );
}
